module.exports = "/packs/media/images/shopping_1-7d13133aabbd62954786a04efc1dfef4.jpg";